import { useEffect, useState } from "react";
const KEY = "upt_bf_deadline_v2";
const DAY = 864e5;

const getDeadline = () => {
  try {
    const saved = Number(localStorage.getItem(KEY));
    const left = saved - Date.now();
    if (saved && left > 0 && left <= DAY) return saved;
    if (saved && left <= 0) return saved;
    const d = Date.now() + DAY;
    localStorage.setItem(KEY, String(d));
    return d;
  } catch {
    return Date.now() + DAY;
  }
};

const deadline = getDeadline();

const calc = () => {
  const d = Math.min(DAY - 1000, Math.max(0, deadline - Date.now()));
  return [Math.floor(d / 36e5), Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
};

export const Countdown = () => {
  const [t, setT] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  const labels = ["horas", "min", "seg"];
  return (
    <div data-testid="offer-countdown" className="flex items-center justify-center gap-2 sm:gap-3">
      {t.map((v, i) => (
        <div key={labels[i]} className="flex items-center gap-2 sm:gap-3">
          <div className="min-w-[56px] rounded-xl bg-white/[0.06] px-2 py-2 text-center ring-1 ring-white/10 sm:min-w-[64px]">
            <div data-testid={`countdown-${labels[i]}`} className="font-display text-2xl tabular-nums text-[var(--cream)] sm:text-3xl">
              {String(v).padStart(2, "0")}
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--cream)]/60">{labels[i]}</div>
          </div>
          {i < 2 && <span className="text-[#d9b45a]/60">:</span>}
        </div>
      ))}
    </div>
  );
};
